import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Markup from 'components/Markup';
import Block from './Block';

import * as styles from './CommonLayout.module.scss';

export default function CommonLayout({ sections }) {
  const getBoxStyles = theme => {
    switch (theme) {
      case 'fullWidthImage':
        return styles.fullBlock;
      default:
        return cn(styles.block, styles.layout);
    }
  };

  return (
    <>
      {sections?.map(({ title, description, blocks }, i) => (
        <section key={title + i} className={cn(styles.section)}>
          {(title || description) && (
            <div className={cn(styles.block, styles.layout)}>
              {title && (
                <Title className={styles.title} tag="h2" size="h3">
                  {title}
                </Title>
              )}
              {description && (
                <Markup tag="p" className={styles.description}>
                  {description}
                </Markup>
              )}
            </div>
          )}
          {blocks?.map((block, i) => (
            <Block
              key={`${block.type}-${i}`}
              theme={block?.theme ?? 'page'}
              type={block.type}
              content={block[block.type]}
              className={getBoxStyles(block?.theme)}
              lazy={false}
            />
          ))}
        </section>
      ))}
    </>
  );
}
